
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import { Link } from "react-router-dom";
import RelatedServices from "../components/RelatedServices";

import SEO from "../components/SEO";
import TravelAgencySchema from "../components/TravelAgencySchema";
import LocalBusinessSchema from "../components/LocalBusinessSchema";
import ServiceSchema from "../components/ServiceSchema";
import BreadcrumbSchema from "../components/BreadcrumbSchema";
import FAQSchema from "../components/FAQSchema";

function FourfiveSeaterbusonrentinpune() {



    const cardData =
    {
        keyword: '45 Seater Bus on Rent in Pune',
        heading: 'Amruta Travels: 45 Seater Bus on Rent in Pune',
        headingDescription: 'Amruta Travels offers 45 Seater Bus on Rent in Pune, providing an ideal travel solution for large groups. Whether it’s a wedding function, corporate event, school picnic, or outstation group tour, our spacious and well-maintained 45-seater buses ensure a smooth and enjoyable journey. With professional drivers, timely service, competitive pricing, and round-the-clock availability, we make group travel convenient and worry-free. Book your 45 Seater Bus with Amruta Travels today and experience travel with safety, comfort, and style!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
            },
            {
                "title": "Aga Khan Palace",
                "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
            },
            {
                "title": "Sinhagad Fort",
                "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
            },
            {
                "title": "Osho Ashram",
                "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
            },
            {
                "title": "Khadakwasla Dam",
                "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
            },
            {
                "title": "Fergusson College Road",
                "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
            },
            {
                "title": "Lal Mahal",
                "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
            },
            {
                "title": "Pune-Okayama Friendship Garden",
                "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
            }
        ],

        "services": [
    {
      "name": "45 Seater Bus for Hire for Outstation",
      "description": "Amruta Travels offers 45-seater buses for outstation trips from Pune, ideal for large groups planning family vacations, pilgrimages, or business tours. Our buses are equipped with spacious seating, luggage compartments, and trained drivers who ensure safe and comfortable travel over long distances."
    },
    {
      "name": "45 Seater Bus for Wedding for Outstation Pune",
      "description": "Planning a destination wedding outside Pune? Amruta Travels provides 45-seater wedding buses that ensure your guests travel in comfort and style. With experienced chauffeurs and well-maintained vehicles, we handle long-distance wedding logistics smoothly and efficiently."
    },
    {
      "name": "45 Seater AC Bus for Hire",
      "description": "Beat the heat on your journey with our 45-seater AC buses for hire in Pune. Perfect for weddings, corporate events, school tours, and long-distance travel, these buses come with powerful air conditioning, comfortable pushback seats, and modern safety features to make your group journey pleasant."
    },
    {
      "name": "45 Seater Non AC Bus for Hire",
      "description": "Looking for a cost-effective transport option for a large group? Amruta Travels offers 45-seater non-AC buses that are ideal for school trips, short-distance travel, community tours, and budget-conscious weddings, without compromising on cleanliness and safety."
    },
    {
      "name": "45 Seater AC Bus for Marriage Function",
      "description": "Make your wedding day hassle-free with Amruta Travels’ 45-seater AC buses for guest transportation. Our buses are perfect for ferrying guests between venues, hotels, and ceremonies, all while offering a cool and comfortable ride in Pune or to nearby destinations."
    },
    {
  "name": "45 Seater Bus for Corporate Events",
  "description": (
    <>
      Amruta Travels provides reliable 45 Seater Bus On Rent in Pune
      for corporate events such as conferences, offsites, team-building
      activities and trade shows. We ensure professional service, on-time
      pickup and drop, and clean, spacious interiors.
    </>
  )
},
    {
      "name": "45 Seater Bus on Rent in Pimpri Chinchwad",
      "description": "If you're located in PCMC, Amruta Travels offers 45-seater bus rental services in Pimpri Chinchwad for all types of group travel. From school trips and corporate outings to religious tours and weddings, we ensure timely service and well-maintained vehicles."
    },
    {
      "name": "45 Seater Bus Hire for School Picnic",
      "description": "Safety and reliability are our top priorities when transporting students. Amruta Travels provides 45-seater buses for school picnics with trained drivers, verified background checks, and comfortable seating to ensure a worry-free day out for both teachers and students."
    },
    {
      "name": "45 Seater Bus Rental for Marriage Function",
      "description": "Amruta Travels offers complete wedding transportation solutions with 45-seater bus rentals in Pune. Our buses are perfect for large family groups or guest shuttles and are operated by drivers who understand tight wedding schedules and hospitality etiquette."
    },
    {
      "name": "45 Seater Bus Rent for Corporate Picnic",
      "description": "Planning a corporate outing or team picnic? Our 45-seater buses are ideal for large teams, offering spacious interiors, clean upholstery, and reliable travel coordination so your employees can relax and enjoy the journey together."
    },
    {
      "name": "45 Seater Bus for Outstation from Pune",
      "description": "Travel outstation from Pune with large groups using Amruta Travels’ 45-seater buses. Ideal for religious tours, company retreats, or extended family trips, these buses are fully serviced and operated by experienced drivers who prioritize safety and comfort."
    },
    {
      "name": "45 Seater Bus Rental Services in Pune",
      "description": "Amruta Travels offers comprehensive 45-seater bus rental services in Pune for various needs—corporate, personal, educational, or religious. Choose from AC or non-AC options and benefit from our timely service, clean vehicles, and competitive pricing."
    },
    {
      "name": "45 Seater Bus Rental Services in Hadapsar",
      "description": "Residents and businesses in Hadapsar can now avail of Amruta Travels’ 45-seater bus rentals for weddings, school trips, and events. We offer flexible packages, prompt support, and door-to-door pickup across the Hadapsar area."
    },
    {
      "name": "45 Seater Bus Rental for Wedding in Pune",
      "description": "Make wedding transport arrangements simple and efficient with our 45-seater buses in Pune. Whether it’s moving guests between venues or planning a procession, Amruta Travels ensures comfort, punctuality, and professional handling of your big day."
    },
    {
      "name": "45 Seater Bus for Company Picnic",
      "description": "Organize a memorable company picnic with Amruta Travels’ 45-seater bus rentals. Enjoy group coordination, reliable pickups, and a smooth journey for your staff with our comfortable, safe, and professionally managed buses tailored for corporate leisure travel."
    }
  ],
  "tableData": [
    ["45 Seater Bus for Hire for Outstation", "45 Seater Bus for Wedding for Outstation Pune"],
    ["45 Seater AC Bus for Hire", "45 Seater Non AC Bus for Hire"],
    ["45 Seater AC Bus for Marriage Function", "45 Seater Bus for Corporate Events"],
    ["45 Seater Bus on Rent in Pimpri Chinchwad", "45 Seater Bus Hire for School Picnic"],
    ["45 Seater Bus Rental for Marriage Function", "45 Seater Bus Rent for Corporate Picnic"],
    ["45 Seater Bus for Outstation from Pune", "45 Seater Bus Rental Services in Pune"],
    ["45 Seater Bus Rental Services in Hadapsar", "45 Seater Bus Rental for Wedding in Pune"],
    ["45 Seater Bus for Company Picnic", ""]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Spacious Group Travel",
    "WhyChoosedescription": "Amruta Travels offers 45 Seater Bus on Rent in Pune, perfect for large group travel. With spacious seating, ample legroom, and air conditioning, our buses ensure a relaxed and enjoyable ride for all passengers."
  },
  {
    "WhyChooseheading": "Ideal for Events, Tours, and Outings",
    "WhyChoosedescription": "Our 45-seater buses are ideal for weddings, corporate events, school trips, and sightseeing tours. No matter the occasion, we provide reliable and comfortable transportation tailored to your group’s needs."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Safety and professionalism come first. Our trained drivers are courteous, punctual, and knowledgeable about routes in and around Pune, ensuring a safe and hassle-free journey for your group."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers competitive and budget-friendly pricing for 45 Seater Bus on Rent in Pune. With clear, upfront rates and no hidden charges, you can plan your group travel expenses with confidence."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Buses",
    "WhyChoosedescription": "Our buses are regularly cleaned and serviced to ensure maximum comfort and hygiene. We maintain high standards for vehicle upkeep to give you a smooth and safe travel experience."
  },
  {
    "WhyChooseheading": "24/7 Availability and Flexible Scheduling",
    "WhyChoosedescription": "Whether it’s an early morning departure or a late-night return, our 45 Seater Bus on Rent in Pune is available 24/7 to match your schedule. We offer flexible booking options to meet your specific needs."
  },
  {
    "WhyChooseheading": "Customized Travel Itineraries",
    "WhyChoosedescription": "We offer fully customizable routes and schedules based on your group’s requirements. Whether it’s multiple pick-up points or planned stopovers, we’ll tailor the travel plan to suit your itinerary."
  },
  {
    "WhyChooseheading": "Easy Booking with Excellent Support",
    "WhyChoosedescription": "Booking a 45 Seater Bus with Amruta Travels is quick and hassle-free. Use our online platform, call our customer support, or visit our office—we provide smooth and convenient booking with full assistance."
  }
]
























    }

const faqData = [
  {
    question: 'How can I rent a 45 seater bus in Pune with Amruta Travels?',
    answer: 'Renting a 45 seater bus in Pune with Amruta Travels is hassle-free. You can book online, contact our support team, or visit our office. We’ll assist you with the booking process and tailor it to suit your group travel needs.',
  },
  {
    question: 'What are the features of the 45 seater bus?',
    answer: 'Our 45 seater buses offer spacious seating with push-back seats, powerful air conditioning, wide windows for sightseeing, and ample luggage space. Ideal for large group travel, school trips, corporate tours, and weddings.',
  },
  {
    question: 'Is the 45 seater bus available for outstation trips?',
    answer: 'Yes, the 45 seater bus is perfect for outstation journeys from Pune. Whether it’s a short excursion or a long-distance tour, our buses ensure a safe, smooth, and comfortable experience.',
  },
  {
    question: 'Can I book the bus for local travel within Pune?',
    answer: 'Absolutely! The 45 seater bus is available for local travel in Pune including city sightseeing, corporate shuttles, event transport, and educational tours.',
  },
  {
    question: 'Are the buses well-maintained and sanitized?',
    answer: 'Yes, all our buses are regularly inspected, maintained, and sanitized before every trip to ensure safety, hygiene, and passenger comfort.',
  },
  {
    question: 'How much does it cost to rent a 45 seater bus in Pune?',
    answer: 'The cost of renting a 45 seater bus depends on the duration, distance, and specific travel needs. Contact us with your trip details for a transparent and customized quote.',
  },
  {
    question: 'Can I request multiple pickup and drop-off locations?',
    answer: 'Yes, we offer flexible routing with multiple pickup and drop-off points. Just provide us your itinerary in advance and we’ll plan accordingly.',
  },
  {
    question: 'Do you provide drivers with the 45 seater bus?',
    answer: 'Yes, all 45 seater bus bookings come with licensed, experienced drivers who are trained to ensure safety, punctuality, and a smooth travel experience.',
  },
  {
    question: 'Is the 45 seater bus suitable for weddings and events?',
    answer: 'Definitely! Our 45 seater bus is a great option for transporting guests to weddings, social gatherings, and special events in and around Pune.',
  },
  {
    question: 'Why choose Amruta Travels for 45 seater bus rental in Pune?',
    answer: 'Amruta Travels is a trusted name for bus rentals in Pune, offering clean buses, skilled drivers, reliable service, and easy booking. We focus on customer comfort and satisfaction.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Kiran Pawar',
    role: 'Corporate Travel Manager, Pune',
    text: 'We booked a 45 seater bus from Amruta Travels for our team outing. The bus was well-maintained, arrived on time, and the driver was courteous. Great service!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Swati Joshi',
    role: 'Wedding Coordinator, Pune',
    text: 'Amruta Travels provided a 45 seater bus for our wedding transportation. Everything was managed professionally and our guests had a smooth and comfortable ride.',
    rating: 5,
  },
];



































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
    {
        src: "/images/gallery/24.jpg",
        alt: "45 Seater AC Bus Hire Pune"
    },
    {
        src: "/images/gallery/28.jpg",
        alt: "Luxury 45 Seater Bus Rental Pune"
    },
    {
        src: "/images/gallery/2.jpg",
        alt: "Corporate Bus Rental Pune"
    },
    {
        src: "/images/gallery/3.jpg",
        alt: "Wedding Bus Hire Pune"
    },
    {
        src: "/images/gallery/24.jpg",
        alt: "Employee Transportation Bus Pune"
    },
    {
        src: "/images/gallery/27.jpg",
        alt: "School Trip Bus Hire Pune"
    },
    {
        src: "/images/gallery/29.jpg",
        alt: "Outstation Bus Rental Pune"
    },
    {
        src: "/images/gallery/30.jpg",
        alt: "Amruta Travels Bus Fleet Pune"
    },
    {
        src: "/images/gallery/31.jpg",
        alt: "Luxury Bus Rental Pune"
    }
];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "45 Seater Bus On Rent in Pune",
  "image": "https://bushireinpune.com/images/keyword/6.jpg",
  "description": "Book a 45 Seater Bus On Rent in Pune with Amruta Travels for corporate events, weddings, school trips, employee transportation, pilgrimage tours and outstation group travel.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6500",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/45-seater-bus-on-rent-in-pune"
  }
};





    return (
    <div>

        <SEO
    title="45 Seater Bus On Rent in Pune | AC & Non-AC Bus Hire | Amruta Travels"
    description="Book a 45 Seater Bus On Rent in Pune with Amruta Travels for weddings, corporate events, school trips, employee transportation and outstation tours."
    canonical="https://bushireinpune.com/45-seater-bus-on-rent-in-pune"
    image="https://bushireinpune.com/images/keyword/6.jpg"
    schema={[productSchema]}
/>

        <TravelAgencySchema />

        <LocalBusinessSchema />

        <ServiceSchema
            serviceType="45 Seater Bus On Rent in Pune"
            url="https://bushireinpune.com/45-seater-bus-on-rent-in-pune"
            description="Book a 45 Seater Bus On Rent in Pune with Amruta Travels for weddings, corporate travel, school trips, employee transportation and outstation tours."
        />

        <BreadcrumbSchema
            pageName="45 Seater Bus On Rent in Pune"
            pageUrl="https://bushireinpune.com/45-seater-bus-on-rent-in-pune"
        />

        <FAQSchema faqs={faqData} />

        <section className="breadcrumb-outer text-center">
            <div className="container">
                <div className="breadcrumb-content">
                    <h1 className="white text-center">
                        {cardData.keyword}
                    </h1>
                </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img
    src="/images/keyword/6.jpg"
    alt="45 Seater Bus On Rent in Pune by Amruta Travels"
    loading="eager"
    fetchPriority="high"
    width="900"
    height="500"
/>
                            <h2
    className="py-1"
    style={{
        color: '#322E77',
        textShadow: '5px 5px 10px rgba(255,255,255,0.7)',
        fontWeight: 'bold'
    }}
>
    {cardData.heading}
</h2>

<p className='fw-bold'>
    {cardData.headingDescription}
</p>

<p>
    If your group size is slightly smaller, you can also explore our{" "}
    <Link to="/40-seater-bus-on-rent-in-pune">
        40 Seater Bus On Rent in Pune
    </Link>{" "}
    for weddings, corporate events and group tours. For larger groups, our{" "}
    <Link to="/50-seater-bus-on-rent-in-pune">
        50 Seater Bus On Rent in Pune
    </Link>{" "}
    can be considered based on your passenger requirement.
</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
    <div key={index} className=" my-4">
        <h4 className="py-1 darkcolorrr">{service.name}</h4>
        <p>{service.description}</p>
    </div>
))}

<p>
    For smaller group requirements, you can also consider our{" "}
    <Link to="/32-seater-bus-on-rent-in-pune">
        32 Seater Bus On Rent in Pune
    </Link>{" "}
    service. If you need higher seating capacity, explore our{" "}
    <Link to="/53-seater-bus-on-rent-in-pune">
        53 Seater Bus On Rent in Pune
    </Link>{" "}
    for large group travel.
</p>
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />
<div className="my-5">

<h2>45 Seater Bus Specifications</h2>

<table className="table table-bordered">

<tbody>

<tr>
<th>Seating Capacity</th>
<td>45 Passengers</td>
</tr>

<tr>
<th>Air Conditioning</th>
<td>Available</td>
</tr>

<tr>
<th>Pushback Seats</th>
<td>Available</td>
</tr>

<tr>
<th>Music System</th>
<td>Available</td>
</tr>

<tr>
<th>Charging Points</th>
<td>Available</td>
</tr>

<tr>
<th>Luggage Space</th>
<td>Large</td>
</tr>

<tr>
<th>Driver Included</th>
<td>Yes</td>
</tr>

<tr>
<th>Suitable For</th>
<td>

Corporate Events,
Wedding Transportation,
Employee Transport,
School Trips,
Tour Packages,
Outstation Travel

</td>
</tr>

</tbody>

</table>

</div>
                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <RelatedServices />

<section className="my-5">

<h2>People Also Search For</h2>

<ul>

    <li>
        <Link to="/32-seater-bus-on-rent-in-pune">
            32 Seater Bus On Rent in Pune
        </Link>
    </li>

    <li>
        <Link to="/35-seater-bus-on-rent-in-pune">
            35 Seater Bus On Rent in Pune
        </Link>
    </li>

    <li>
        <Link to="/40-seater-bus-on-rent-in-pune">
            40 Seater Bus On Rent in Pune
        </Link>
    </li>

    <li>
        45 Seater Bus Hire in Pune
    </li>

    <li>
        <Link to="/50-seater-bus-on-rent-in-pune">
            50 Seater Bus On Rent in Pune
        </Link>
    </li>

    <li>
        <Link to="/53-seater-bus-on-rent-in-pune">
            53 Seater Bus On Rent in Pune
        </Link>
    </li>

    <li>Luxury Bus Rental Pune</li>
    <li>Corporate Bus Rental Pune</li>
    <li>Wedding Bus Hire Pune</li>
    <li>Employee Transportation Pune</li>

</ul>

</section>

<div className="row twm-faq-section-1 m-b30">

                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
    <Link
        to="/bus-on-rent-in-pune"
        className="d-flex justify-content-around align-items-center"
    >
        <div className="b1">
            <img
                src={e.place}
                alt={e.text}
                loading="lazy"
            />
        </div>

        <div className="b2">
            <span className="px-3">{e.text}</span>
        </div>
    </Link>
</div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default FourfiveSeaterbusonrentinpune;